/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessageQueue = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 22H2V2h6zm-2-2V4H4v16zm16-8-5.707 5.707-1.414-1.414L18.172 13h-6.171L12 22h-2V2h2l.001 9h6.171l-3.293-3.293 1.414-1.414z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMessageQueue as MessageQueue };
